export default __webpack_public_path__ + "static/media/under.ebac3bcc.mp4";